export default __webpack_public_path__ + "static/mark-masterson-8af629302eb95ad6dde056a8a0cdafc1.gif";